export const CURRENCY_HINTS = {
  INR: '(₹)',
  USD: '($)',
  GBP: '(£)',
  EUR: '(€)',
  AUD: '(A$)',
  CAD: '(C$)',
  NGN: '(₦)',
  KES: '(KSh)',
  GHS: '(₵)',
  ZAR: '(R)',
  PKR: '(Rs)',
  BDT: '(৳)',
  LKR: '(Rs)',
  IDR: '(Rp)',
  PHP: '(₱)',
  MXN: '($)',
  BRL: '(R$)',
  OTHER: '',
}

export const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
  GBP: '£',
  EUR: '€',
  AUD: 'A$',
  CAD: 'C$',
  NGN: '₦',
  KES: 'KSh',
  GHS: '₵',
  ZAR: 'R',
  PKR: 'Rs',
  BDT: '৳',
  LKR: 'Rs',
  IDR: 'Rp',
  PHP: '₱',
  MXN: '$',
  BRL: 'R$',
  OTHER: '',
}

export const PM_LABELS = {
  controlled: 'Controlled Production',
  guerrilla: 'Flexible / Guerrilla',
  documentary: 'Documentary / Real-time',
  zerobud: 'Zero Budget / Resource-driven',
}

export const LOC_TYPE_LABELS = {
  controlled: 'Controlled (Indoor/Set)',
  mixed: 'Mixed',
  uncontrolled: 'Uncontrolled (Outdoor/Real)',
}

export const STREAM_MESSAGES = [
  'Reading project inputs...',
  'Evaluating production risks...',
  'Analyzing budget viability...',
  'Assessing schedule reality...',
  'Generating insights...',
  'Finalizing report...',
]
